import React, { Component } from "react";
import Loading from '../../hoc/Loading/Loading';
import * as actionCreators from '../../modules/actions/index';
import { connect } from 'react-redux';
import axios from '../../axios';
// import './Events.css';
import * as url from '../../utils/url';
import {eventActionRoles,rsvpRoles, eventRoles} from '../../utils/constants';
import Select from 'react-select';
import {customSingleValue, customOptions, eventDetailsCss} from './RsvpSelectOptions'
import './AddToEvent.css'


 const rsvpWithIcons = rsvpRoles.map( e=> {
        if(e.value==0){
          e.icon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
          className="rsvp_role_select_options_img" viewBox="0 0 16 16">
          <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.026A2 2 0 0 0 2 14h6.256A4.493 4.493 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586l-1.239-.757ZM16 4.697v4.974A4.491 4.491 0 0 0 12.5 8a4.49 4.49 0 0 0-1.965.45l-.338-.207L16 4.697Z"/>
          <path d="M16 12.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Zm-1.993-1.679a.5.5 0 0 0-.686.172l-1.17 1.95-.547-.547a.5.5 0 0 0-.708.708l.774.773a.75.75 0 0 0 1.174-.144l1.335-2.226a.5.5 0 0 0-.172-.686Z"/>
        </svg>
        } else if (e.value==1){
          e.icon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
          className="rsvp_role_select_options_img" viewBox="0 0 16 16">
          <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
        </svg>
        } else if(e.value==2){
          e.icon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
          className="rsvp_role_select_options_img" viewBox="0 0 16 16">
          <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z"/>
        </svg>
        } else if (e.value==3){
          e.icon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
          className="rsvp_role_select_options_img" viewBox="0 0 16 16">
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
        </svg>
        }
        return e
  })

// const CustomOption = ({ children, ...props }) => {
//   return (  
//     <components.Option {...props}>
//       {/* <img src={props.data.icon} className="rsvp_role_select_options_img"/> */}
//       {props.data.icon}
//       <span className="rsvp_role_select_options_txt" >{children}</span>
//     </components.Option>
//   );
// };

// const SingleValue = ({ children, ...props }) => {
//   return (  
//     <components.SingleValue {...props}>
//       <span className="rsvp_role_select_options_component">
//       {/* <img src={props.data.icon} className="rsvp_role_select_options_img"/> */}
//       {props.data.icon}
//       <span className="rsvp_role_select_options_txt" >{children}</span>
//       </span>
//     </components.SingleValue>
//   );
// };




class AddToEvent extends Component {

    constructor(props) {
        super(props);
        this.state = {
          curr_rsvp:this.props.curr_rsvp!=null?this.props.curr_rsvp:''
        };
      }


  componentDidMount(){
    let{curr_rsvp}=this.state
    if(this.props.curr_rsvp && this.props.curr_rsvp!=null){
      this.setState({curr_rsvp:this.props.curr_rsvp})
    } else if( curr_rsvp==null || !curr_rsvp){
      this.findCurrentRsvpStatus()
    }  
  }

 
  findCurrentRsvpStatus= status_changed =>{
    let {item, user}=this.props, that = this, {curr_rsvp}=this.state, 
    payload = {
      userId: user.profile._id, 
      eventId: item.eventId?item.eventId:item._id,
      organizationId: item.organizationID? item.organizationID: item.organizationId,
    }
    if(curr_rsvp=='' || curr_rsvp==null || curr_rsvp==undefined){
      axios.post(url.getSingleUserEvent, payload).then(({ data }) => {
        let resp = data.data
        that.setState({
          curr_rsvp: resp&&resp.hasOwnProperty('rsvp')?resp.rsvp:null,
          rsvp_updated:false,
          // item:this.props.item
        })
      }).catch((error) => {
        console.log(error);
      }) 
    } 
    // else if(status_changed && status_changed.isUpdated){
    //   that.setState({
    //     curr_rsvp: status_changed.rsvp,
    //     item:this.props.item
    //   })
    // }
  }


  handleUserStatus=(new_rsvp)=>{
    let{value, label}=new_rsvp

    if(value!=1000){ //1000 is the value for no RSVP

    let{curr_rsvp}=this.state
    let{item, user}=this.props

    // console.log('curr_rsvp---- ', curr_rsvp)
    // console.log('new rsvp--- ', new_rsvp)

    let eventId = item&&item.eventId&& Object.keys(item.eventId).length>0?item.eventId: item._id

    let payload ={
      condition: {
        userId: user.profile._id,
        eventId,
      },
      organizationId: user.profile.organizationId._id,
      noLoader:true
    }

    if(curr_rsvp==null || !curr_rsvp){
      payload.update= {  
                        rsvp:{value, label, date: new Date(), updated:null}, 
                        role:{value:eventRoles[eventRoles.length-1].value,
                                label:eventRoles[eventRoles.length-1].label, date: new Date()},
                        organizationId: user.profile.organizationId._id }
    } else {
      payload = { ...payload, old_rsvp: curr_rsvp,  
              update: { rsvp: {  value, label, date:curr_rsvp.date ,updated: new Date()},}}
    }

    this.setState({curr_rsvp: {...new_rsvp} })
    let that=this

    axios.post(url.changeEventStatus, payload).then(({ data }) => {
      let resp = data.data
      let {updated_event} = data.data
      console.log('status --- ', resp)
      // return event_rsvps
      if(that.props.from_module&&that.props.from_module=="Toolkit"){
        that.props.updated_user_rsvp_status(resp)
        let tool_attr = [
          'invitee_count', 'attendee_count', 'rsvp_count', 'interested_count','going_count',
        ]
         
  
        let updated_item = Object.keys(updated_event)
                          .filter(e=> tool_attr.indexOf(e)>-1)
                          .reduce((acc, key)=>{ acc[key]=updated_event[key]; return acc}, {})
        
        that.props.onToolInfoCompleted(updated_item)
      }

    
      // that.props.findCurrentRsvpStatus()
    }).catch((error) => {
      console.log(error);
    }) 

    }
  }


  renderEventOptions=()=>{
    let{curr_rsvp}=this.state, res
    // let{isParentType}=this.props
    if(curr_rsvp==null || !curr_rsvp){
      res =  rsvpWithIcons.filter(e=> !e.isHidden && e.value!=3)
    } else {
      res =  rsvpWithIcons.filter(e=> !e.isHidden)
    }
    return res 
  }



  render() {
    let{curr_rsvp}=this.state
    return (    
        <div className="add_to_event_select_container">
          {this.props.disable?
          <div className={`n_sl_ev_add_00 ${curr_rsvp!=null&&curr_rsvp.value? curr_rsvp.value==0?'ev_rsvp_invited' :curr_rsvp.value==1?'ev_rsvp_01':curr_rsvp.value==2?'ev_rsvp_02':'':'ev_rsvp_nst_1000'}`}>
                {(curr_rsvp && curr_rsvp!=null)?  
                  rsvpWithIcons.filter(e=> e.value== curr_rsvp.value)[0].label: 
                  rsvpWithIcons.filter(e=> e.value==  1000)[0].label
                }
          </div>
          :
             <Select
              className={`${curr_rsvp!=null&&curr_rsvp.value? curr_rsvp.value==0?'ev_rsvp_invited' :curr_rsvp.value==1?'ev_rsvp_01':curr_rsvp.value==2?'ev_rsvp_02':'':'ev_rsvp_nst_1000'}`}
              value={(curr_rsvp && curr_rsvp!=null)?  
                      rsvpWithIcons.filter(e=> e.value== curr_rsvp.value)[0]: 
                      rsvpWithIcons.filter(e=> e.value==  1000)[0] 
                    }
              onChange={(r) => this.handleUserStatus(r)}
              isClearable={false}
              data_arr={rsvpWithIcons}
              isSearchable={false} 
              options={this.renderEventOptions()} 
              placeholder="Click to RSVP"
              menuPlacement='top'
              menuShouldScrollIntoView={true} 
            />
         }

        </div>
      );
  }
}



const mapStateToProps = state => {
    return {
      user: state.user,
      objectives: state.enterpriseObjective.objectives
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
      onFetchEnterpriseObjectives: (data) => dispatch(actionCreators.storeEnterpriseObjectives(data)),
      orgChangeSuccess: (data)=> dispatch(actionCreators.orgChangeSuccess(data)),
      resetObjective : () => dispatch(actionCreators.resetEnterpriseObjectives()),
      onAddToolSuccess: (data) => dispatch(actionCreators.addToolSuccess(data)),
      onToolInfoCompleted: (data) => dispatch(actionCreators.toolInfoCompleted(data)),

    }
  }
  
  export default connect(mapStateToProps, mapDispatchToProps)(Loading(AddToEvent, axios));